import React from 'react';
import { VerifierModel } from 'services/EpdClient';
import { EPDVerifierModel } from 'types/types';
import CertificationBodyCard from './CertificationBodyCard';

interface CertificationBodiesListProps {
  certificationBody: EPDVerifierModel | null;
  bodies: VerifierModel[];
  selectedVerifier: VerifierModel | undefined;
  onSelectVerifier: any;
  onAddBody: any;
  buttonsAreDisabled?: boolean;
}

const CertificationBodiesList: React.FunctionComponent<CertificationBodiesListProps> = ({
  certificationBody,
  bodies,
  selectedVerifier,
  onSelectVerifier,
  onAddBody,
  buttonsAreDisabled,
}) => (
  <div>
    {bodies.map((body) => (
      <CertificationBodyCard
        key={body.id}
        data={body}
        onSelectBody={() => onSelectVerifier((prev: VerifierModel | undefined) => (prev?.id === body.id ? undefined : body))}
        onAddBody={onAddBody}
        expanded={selectedVerifier?.id === body.id}
        buttonsAreDisabled={
          body.id === certificationBody?.companyId ||
          body.information === certificationBody?.companyName ||
          buttonsAreDisabled
        }
      />
    ))}
  </div>
);

export default CertificationBodiesList;
